<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      :visible="dialogVisible"
      width="500px"
      @close="handleCloseDialog"
      append-to-body
      center
    >
      <el-form ref="form" :model="form" label-width="100px"  @submit.native.prevent>
        <el-form-item label="支付流水号">
          <el-input ref="gain" v-model="AuthCode" :autofocus="showAuthCode"></el-input>
        </el-form-item>
        <el-form-item label="应付款">
          <el-input v-model="form.moneyValueToPay2" :disabled="true">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" native-type="button" @click="handleCloseDialog">取 消</el-button>
          <el-button type="primary" native-type="submit" @click="handleClick">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import showdialog from "@/minxs/showdialog";
import ParkLotMix from "@/minxs/parkLotId";
import { scanPay } from "@/api/module/park";

export default {
  data() {
    return {
      AuthCode: undefined,
    };
  },
  mixins: [showdialog, ParkLotMix],
  computed: {
    tenantId: function () {
      return this.$store.state.user.tenantId;
    },
    showAuthCode: function () {
      this.$nextTick(() =>{
        this.$refs.gain.focus()
      });
      return this.$store.state.order.showAuthCode;
    },
  },
  props: {
    form: {
      type: Object,
      default: function() {
        return {
          moneyValueToPay2: 1,
        }
      }
    },
  },
  watch: {
  },
  methods: {
    async handleClick() {
      // scanPay()
      if (!this.AuthCode) {
        this.$message({ message: '支付流水号错误，请重新扫码', type: "error" });
        return;
      }
      let param = {
        parkLotId: this.form.parkLotId,
        orderId: this.form.id,
        plateNumber: this.form.plateNumber,
        price: this.form.moneyValueToPay2,
        authCode: this.AuthCode,
      };
      // console.log(param);
      let res = await scanPay(param);
      if (res.state === "success") {
        this.$message({ message: res.message, type: "success" });
        this.AuthCode = undefined;
        this.handleCloseDialog();
      } else {
        this.$message({ message: res.message, type: "error" });
      }
    },
    handleCloseDialog() {
      this.handleClose();
      this.$store.dispatch("SetShowAuthCode", false);
    },
  },
};
</script>
